module.exports = __webpack_public_path__ + "static/media/Seam_4552.70b94601.jpg";